/* Checkout novo a cada retorno.
   A Shopify usa o token do carrinho como ID do checkout (/checkouts/cn/<token>). Quem volta ao checkout com o
   mesmo carrinho reabre o MESMO checkout: o abandonado antigo só é atualizado (fica na data antiga da lista,
   que ordena por "Criado em") e o e-mail de recuperação não sai de novo. Isso esconde, por exemplo, quem gera
   um Pix, não paga e volta outro dia.
   Se o cliente já foi ao checkout com este carrinho há mais de LIMITE, recriamos o carrinho com os mesmos itens
   (propriedades, nota, atributos e cupons) antes de seguir: checkout novo, abandonado novo no topo e nova
   recuperação. Qualquer falha cai no comportamento antigo e segue para o checkout normalmente. */
(() => {
  const CHAVE = 'mk-ck';
  const LIMITE = 15 * 60 * 1000;
  const RAIZ = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const JSON_POST = { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' } };

  const ler = () => { try { return JSON.parse(localStorage.getItem(CHAVE) || 'null'); } catch (e) { return null; } };
  const gravar = (t) => { try { localStorage.setItem(CHAVE, JSON.stringify({ t, at: Date.now() })); } catch (e) {} };
  const tokenDe = (c) => String((c && c.token) || '').split('?')[0];
  const cookieCart = () => document.cookie.split('; ').find((c) => c.indexOf('cart=') === 0);
  const carrinho = () => fetch(RAIZ + 'cart.js', { cache: 'no-store' }).then((r) => r.json());

  async function recriar(cart) {
    const velho = cookieCart();
    const items = cart.items.map((i) => {
      const o = { id: i.variant_id, quantity: i.quantity };
      if (i.properties && Object.keys(i.properties).length) o.properties = i.properties;
      if (i.selling_plan_allocation) o.selling_plan = i.selling_plan_allocation.selling_plan.id;
      return o;
    });
    document.cookie = 'cart=; path=/; max-age=0';
    const r = await fetch(RAIZ + 'cart/add.js', { ...JSON_POST, body: JSON.stringify({ items }) });
    if (!r.ok) {
      // devolve o carrinho antigo intacto
      if (velho) document.cookie = velho + '; path=/; max-age=1209600; samesite=lax';
      return cart;
    }
    const upd = {};
    const cupons = (cart.discount_codes || []).filter((d) => d.applicable).map((d) => d.code);
    if (cupons.length) upd.discount = cupons.join(',');
    if (cart.note) upd.note = cart.note;
    if (cart.attributes && Object.keys(cart.attributes).length) upd.attributes = cart.attributes;
    if (Object.keys(upd).length) await fetch(RAIZ + 'cart/update.js', { ...JSON_POST, body: JSON.stringify(upd) });
    const novo = await carrinho();
    document.dispatchEvent(new CustomEvent('mk:carrinho-recriado', { detail: { de: tokenDe(cart), para: tokenDe(novo) } }));
    return novo;
  }

  async function preparar() {
    try {
      let cart = await carrinho();
      if (!cart.item_count) return;
      const reg = ler();
      if (reg && reg.t === tokenDe(cart) && Date.now() - reg.at > LIMITE) cart = await recriar(cart);
      gravar(tokenDe(cart));
    } catch (e) {}
  }

  // nunca segura o cliente mais que 5 s
  window.mkPrepararCheckout = () => Promise.race([preparar(), new Promise((ok) => setTimeout(ok, 5000))]);

  // página /cart e carrinho do Horizon: <button type="submit" name="checkout"> dentro do form /cart
  document.addEventListener('submit', (e) => {
    const s = e.submitter;
    if (!s || s.name !== 'checkout' || e.defaultPrevented) return;
    e.preventDefault();
    s.disabled = true;
    window.mkPrepararCheckout().finally(() => { location.href = RAIZ + 'checkout'; });
  });
})();
